import { render, staticRenderFns } from "./CourseCard.vue?vue&type=template&id=a38acb88&"
import script from "./CourseCard.vue?vue&type=script&lang=js&"
export * from "./CourseCard.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CourseCard.vue?vue&type=style&index=0&id=a38acb88&prod&lang=stylus&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports